import { guestLinks } from '@map/components/GuestArea/links';
import useFeatureIsAccessible from '@map/hooks/useFeatureIsAccessible';
import { makeStyles } from '@map/theme';
import NavButton from '@ui/NavButton';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(({ spacing }) => ({
  button: {
    marginTop: spacing(6),
  },
}));

type Props = {
  to: 'phone' | 'email';
};

const PhoneEmailTransferButton: FC<Props> = ({ to }) => {
  const { classes } = useStyles();
  const phoneAuthAccessible = useFeatureIsAccessible('phoneNumberAuth');
  const emailAuthAccessible = useFeatureIsAccessible('emailAuth');

  if ((to === 'phone' && !phoneAuthAccessible) || (to === 'email' && !emailAuthAccessible)) {
    return null;
  }

  return (
    <NavButton
      className={classes.button}
      variant="tertiary"
      to={to === 'email' ? guestLinks.registerEmail() : guestLinks.registerPhone()}
      fullWidth={true}
      replace={true}
    >
      {to === 'email' ? (
        <FormattedMessage id="registration.sign_up_alternative.email" />
      ) : (
        <FormattedMessage id="registration.sign_up_alternative.phone" />
      )}
    </NavButton>
  );
};

export default memo(PhoneEmailTransferButton);
